import { render, staticRenderFns } from "./OrderLogsTable.vue?vue&type=template&id=4eec24cb&scoped=true&"
import script from "./OrderLogsTable.vue?vue&type=script&lang=js&"
export * from "./OrderLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderLogsTable.vue?vue&type=style&index=0&id=4eec24cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec24cb",
  null
  
)

export default component.exports